<template>
  <el-form label-position="top" size="small">
    <el-row :gutter="20" justify="center">
      <el-col :xs="16" :sm="8">
        <el-checkbox label="Интернет-эквайринг"></el-checkbox>
      </el-col>
      <el-col :xs="16" :sm="8">
        <el-checkbox label="ЕРИП Расчет"></el-checkbox>
      </el-col>
      <el-col :xs="16" :sm="8">
        <el-checkbox label="Онлайн-касса Belqi"></el-checkbox>
      </el-col>
    </el-row>
    <div class="top_line_modal"></div>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <h4>Данные о предприятии</h4>
        <el-form-item label="URL сайта">
          <el-input></el-input>
        </el-form-item>
        <el-form-item label="Наименование организации или ИП*">
          <el-input></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <h4>Данные о предприятии</h4>
        <el-form-item label="ФИО контактного лица*">
          <el-input></el-input>
        </el-form-item>
        <el-form-item label="Контактный телефон*">
          <el-input></el-input>
        </el-form-item>
        <el-form-item label="Контактный e-mail*">
          <el-input></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: 'company-form'
}
</script>
